import { FormikProps } from "formik";
import { ICTextArea } from "../form/index";
import { cn } from "../../lib";

interface ICustomFormikTextArea<T> extends FormikProps<T> {
  name: keyof T;
  placeholder?: string;
  label?: string;
  containerClassName?: string;
  onChangeText?: (text: string) => void;
  disabled?: boolean;
  required?: boolean;
  maxLength?: number;
}

const ICFormikTextArea = <T extends Object>(
  props: ICustomFormikTextArea<T>
) => {
  const { handleChange, handleBlur, touched, errors, values } = props;
  const {
    name,
    placeholder,
    label,
    containerClassName,
    onChangeText,
    disabled,
    required,
    maxLength,
  } = props;
  const fieldName = props.name as string;

  return (
    <div className={cn({ [`${containerClassName}`]: containerClassName })}>
      <ICTextArea
        type="text"
        id={fieldName}
        placeholder={placeholder}
        onChange={(event) =>
          onChangeText ? onChangeText(event.target.value) : handleChange(event)
        }
        onBlur={handleBlur}
        errorMessage={touched[name] && errors[name] ? errors[name] : ""}
        value={values[name] as string}
        disabled={disabled}
        label={label}
        required={required}
        maxLength={maxLength}
      />
    </div>
  );
};

export default ICFormikTextArea;
